// src/routes/publisher_routes.tsx
import React, { ComponentType, FC } from 'react';
import PublisherLayoutComponent from '../Layout/PublisherLayout/PublisherLayoutComponent';

import Dashboard from '../pages/Publisher/Dashboard/Dashboard';
import Gamics from '../pages/Publisher/Gamics/Gamics';
import AiConnect from '../pages/Publisher/AiConnect/AiConnect';
import Campaign from '../pages/Publisher/Campaign/Campaign';
import Billing from '../pages/Publisher/Billing/Billing';
import AccountSetting from '../pages/Publisher/AccountSetting/AccountSetting';
import AddGamics from '../pages/Publisher/Gamics/AddGamics';
import EditGamics from '../pages/Publisher/Gamics/EditGamics';
import AddCampaign from '../pages/Publisher/Campaign/AddCampaign';
import Support from '../pages/Publisher/Support/Support';
import AddSupportTicket from '../pages/Publisher/Support/AddSupportTicket';
import { ShowTicket } from '@/pages/Publisher/Support/ShowTicket';
import PublisherAuthMiddleware from '@/middleware/PublisherAuthMiddleware';
import Guide from '@/pages/Publisher/Guide/Index';
import { ENABLE_CAMPAIGN } from '@/config/features';

const withPublisherLayout =
  <P extends object>(Page: ComponentType<P>): FC<P> =>
  (props) => (
    <PublisherLayoutComponent>
      {React.createElement(Page, props)}
    </PublisherLayoutComponent>
  );

// routes map
const publisher_routes: Record<string, ComponentType<any>> = {
  '/dashboard': withPublisherLayout(PublisherAuthMiddleware(Dashboard)),
  '/gamics': withPublisherLayout(PublisherAuthMiddleware(Gamics)),
  '/ai-connect': withPublisherLayout(PublisherAuthMiddleware(AiConnect)),
  '/billing': withPublisherLayout(PublisherAuthMiddleware(Billing)),
  '/account-setting': withPublisherLayout(PublisherAuthMiddleware(AccountSetting)),
  '/add-gamics': withPublisherLayout(PublisherAuthMiddleware(AddGamics)),
  '/edit-gamics/:id': withPublisherLayout(PublisherAuthMiddleware(EditGamics)),
  ...(ENABLE_CAMPAIGN
    ? {
        '/campaign': withPublisherLayout(PublisherAuthMiddleware(Campaign)),
        '/add-campaign': withPublisherLayout(PublisherAuthMiddleware(AddCampaign)),
      }
    : {}),
  '/support-tickets': withPublisherLayout(PublisherAuthMiddleware(Support)),
  '/add-support-ticket': withPublisherLayout(PublisherAuthMiddleware(AddSupportTicket)),
  '/show-ticket/:id': withPublisherLayout(PublisherAuthMiddleware(ShowTicket)),
  '/guide': withPublisherLayout(PublisherAuthMiddleware(Guide)),
};

export default publisher_routes;
